import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'

import { useCommonTrackingProperties } from '~publish/hooks/useCommonTrackingProperties'

export type DismissMethod = 'close_button' | 'set_up_now' | 'learn_more'

export function usePublicGraphQLApiModalTracking(): {
  trackDialogViewed: () => boolean
  trackDialogDismissed: (method: DismissMethod) => void
} {
  const commonTrackingProperties = useCommonTrackingProperties()
  const location = useLocation()

  const trackDialogViewed = useCallback((): boolean => {
    if (!commonTrackingProperties.organizationId) return false

    BufferTracker.componentRendered({
      ...commonTrackingProperties,
      path: location.pathname,
      componentName: 'PublicGraphQLApiModal',
      componentDetails: JSON.stringify({ event: 'viewed' }),
    })
    return true
  }, [commonTrackingProperties, location.pathname])

  const trackDialogDismissed = useCallback(
    (method: DismissMethod) => {
      if (!commonTrackingProperties.organizationId) return

      BufferTracker.componentRendered({
        ...commonTrackingProperties,
        path: location.pathname,
        componentName: 'PublicGraphQLApiModal',
        componentDetails: JSON.stringify({
          event: method === 'close_button' ? 'dismissed' : 'cta_clicked',
          cta: method,
        }),
      })
    },
    [commonTrackingProperties, location.pathname],
  )

  return {
    trackDialogViewed,
    trackDialogDismissed,
  }
}
